import React from "react";
import { Stack } from "expo-router";
import Constants from "expo-constants";
import { Colors } from "@/constants/Colors";
import useWindow from "@/hooks/useWindow";

const BillsLayout = () => {
  const { isDesktop } = useWindow();
  return (
    <Stack
      screenOptions={{
        contentStyle: {
          paddingTop: Constants.statusBarHeight,
          backgroundColor: Colors.background,
          width: isDesktop ? 600 : undefined,
          alignSelf: isDesktop ? "center" : undefined,
        },
      }}
    >
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="[id]" options={{ headerShown: false }} />
      <Stack.Screen name="upload" options={{ headerShown: false }} />
      <Stack.Screen name="detail" options={{ headerShown: false }} />
      <Stack.Screen name="profile-info" options={{ headerShown: false }} />
    </Stack>
  );
};

export default BillsLayout;
